import { render, staticRenderFns } from "./GroupAbsencePage.vue?vue&type=template&id=645b3692&scoped=true&"
import script from "./GroupAbsencePage.vue?vue&type=script&lang=js&"
export * from "./GroupAbsencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b3692",
  null
  
)

export default component.exports